import React from 'react';

const AdminIcon = ({ style }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M12 2L2 7V12C2 16.97 5.3 21.47 10 22.84V20.66C6.5 19.45 4 16 4 12V8.3L12 4.19L20 8.3V12C20 16 17.5 19.45 14 20.66V22.84C18.7 21.47 22 16.97 22 12V7L12 2Z"
      fill="currentColor"
    />
    <path
      d="M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
      fill="currentColor"
    />
    <path
      d="M12 16C10.33 16 9 17.33 9 19H15C15 17.33 13.67 16 12 16Z"
      fill="currentColor"
    />
  </svg>
);

export default AdminIcon;